import ForgotPwd from "@/service/forgot-password";

export default {
  name: "password-reset",
  components: {},
  props: ["token", "email"],
  data() {
    return {
      data: {
        email: "",
        pwd: "",
        confirmPwd: "",
        token: ""
      },
      errors: {},
      err_response: "",
      btn_submit: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    resetPassword() {
      this.data.token = this.$route.params.token;
      this.btn_submit = true;
      ForgotPwd.resetPwd(this.data)
        .then(res => {
          this.$router.replace({
            name: "login",
            params: { content: "Change password success" }
          });
        })
        .catch(err => {
          this.btn_submit = false;
          if(err.status === 422){
            this.errors = err.data.error;
            this.err_response= ""
          }
          if(err.status === 410){
            this.err_response = err.data.error;
            this.errors ={}
          }
          console.log(this.errors, this.err_response,err);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/forgot-password/password-reset/password-reset.js